import posthog from 'posthog-js';

export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  try {
    posthog.capture(eventName, properties);
  } catch (e) {
    console.error('PostHog tracking error:', e);
  }
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  try {
    posthog.identify(userId, properties);
  } catch (e) {
    console.error('PostHog identify error:', e);
  }
}

export function setBusinessGroup(bid: string, properties?: Record<string, unknown>) {
  try {
    posthog.group('business', bid, properties);
  } catch (e) {
    console.error('PostHog group error:', e);
  }
}

export function resetPostHog() {
  try {
    posthog.reset();
  } catch (e) {
    console.error('PostHog reset error:', e);
  }
}
